module.exports = __webpack_public_path__ + "static/media/searchimage.0559d01c.jpg";